// extracted by mini-css-extract-plugin
export default {"projects-wrapper":"workproject_projects-wrapper__kePkB","project-content":"workproject_project-content__uK2yD"};